import { Topic } from './topic.entity';

// Public topic references expose the BaseEntity fields, title and rare-disease flag.
export const PUBLIC_TOPIC_FIELDS: (keyof Topic)[] = [
  'id', 'createdAt', 'updatedAt', 'title', 'isRareDisease',
];
const PUBLIC_TOPIC_COUNT_FIELDS: (keyof Topic)[] = [
  'organizationCountGa', 'organizationCountCommunity', 'organizationCountShGroup',
  'organizationCountBa', 'organizationCountOther',
];

export function getPublicTopic(topic: Topic, includeOrganizationCounts = false): Topic {
  const fields = includeOrganizationCounts
    ? [...PUBLIC_TOPIC_FIELDS, ...PUBLIC_TOPIC_COUNT_FIELDS]
    : PUBLIC_TOPIC_FIELDS;

  return Object.fromEntries(fields
    .filter(field => Object.prototype.hasOwnProperty.call(topic, field))
    .map(field => [field, topic[field]])) as unknown as Topic;
}
